module.exports = __webpack_public_path__ + "img/illu-hole-full.cc76bf06.svg";